import { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';

function SignupPage({ onSwitchToLogin }) {
  const { signup, loginWithGoogleCredential } = useAuth();
  const { t } = useTranslation('auth');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    const trimmedUsername = username.trim();
    const trimmedEmail = email.trim();
    if (!trimmedUsername || !trimmedEmail || !password) {
      setError(t('signup.fillAllFields'));
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
      setError(t('signup.invalidEmail'));
      return;
    }
    if (password.length < 4) {
      setError(t('signup.passwordTooShort'));
      return;
    }
    if (password !== confirmPassword) {
      setError(t('signup.passwordMismatch'));
      return;
    }

    setIsSubmitting(true);
    const result = await signup(trimmedUsername, trimmedEmail, password);
    setIsSubmitting(false);
    if (!result.success) {
      setError(result.error);
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    setError('');
    const result = await loginWithGoogleCredential(credentialResponse.credential);
    if (!result.success) {
      setError(result.error || t('signup.googleFailed'));
    }
  };

  return (
    <div className="login-page">
      <form onSubmit={handleSubmit} className="card login-card">
        <h1 className="login-title">Zlux</h1>
        <p className="login-subtitle">{t('signup.subtitle')}</p>
        <label>
          {t('signup.username')}
          <input autoFocus value={username} onChange={(event) => setUsername(event.target.value)} />
        </label>
        <label>
          {t('signup.email')}
          <input type="email" value={email} onChange={(event) => setEmail(event.target.value)} />
        </label>
        <label>
          {t('signup.password')}
          <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} />
        </label>
        <label>
          {t('signup.confirmPassword')}
          <input type="password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} />
        </label>
        {error && <span className="error-text">{error}</span>}
        <button className="primary-btn standout-btn" type="submit" disabled={isSubmitting}>{isSubmitting ? t('signup.submitting') : t('signup.submit')}</button>

        <div className="login-divider"><span>{t('signup.or')}</span></div>

        <div className="google-btn-wrap">
          <GoogleLogin onSuccess={handleGoogleSuccess} onError={() => setError(t('signup.googleFailed'))} theme="outline" shape="pill" text="signup_with" />
        </div>

        <button type="button" className="text-btn auth-switch-btn" onClick={onSwitchToLogin}>{t('signup.switchPrompt')}</button>

        <p className="login-hint">{t('signup.dataHint')}</p>
      </form>
    </div>
  );
}

export default SignupPage;
